import Vue from 'vue'

import Router from 'vue-router'
const Home = () =>
  import("@/views/home/Home.vue");
//const OrderList = () =>
//  import("@/views/orderList/OrderList.vue");
const OrderDetail = () =>
  import("@/views/orderDetail/OrderDetail.vue");
const ReimBurse = () =>
  import("@/views/reimBurse/reimburse");
const MyLogistics = () =>
  import("@/views/myLogistics/MyLogistics.vue");
const MyReport = () =>
  import("@/views/myReport/MyReport.vue");
const SystemNotice = () =>
  import("@/views/systemNotice/SystemNotice.vue");
//const MyProduct = () =>
//  import("@/views/myProduct/MyProduct.vue");
const Invoice = () =>
  import("@/views/invoice/Invoice.vue"); // 发票信息
const Allot = () =>
  import("@/views/allot/Allot.vue"); // 酒店分配
const Honor = () =>
  import("@/views/honor/Honor.vue"); //荣誉
const Login = () =>
  import("@/views/login/Login.vue"); //登录
const AuthCallback = () =>
  import("@/views/login/AuthCallback.vue"); // SSO 回调
const Err = () =>
  import("@/views/err/Err.vue"); //404
const ChooHotel = () =>
  import("@/views/chooHotel/ChooHotel.vue"); //选择酒店    
const advancePayment = () =>
  import("@/views/advancePayment/advancepayment.vue"); //提前申请开票  
const franchise_settlementbill = () =>
  import("@/views/bill/franchise_settlementbill.vue"); //结算清单查询   
const SettlementDetailed = () =>
  import("@/views/settlementDetailed/SettlementDetailed.vue"); //结算清单明细
const SettlementSheet = () =>
  import("@/views/settlementSheet/SettlementSheet.vue"); //结算单     
const InvoiceEntry = () =>
  import("@/views/invoiceEntry/InvoiceEntry.vue"); //录入发票  
const NewInvoiceEntry = () =>
  import("@/views/newInvoiceEntry/NewInvoiceEntry.vue"); //订单入口录入发票  
const OrderPrintingDetails = () =>
  import("@/views/OrderPrintingDetails/OrderPrintingDetails.vue"); //订单打印  
const ReconciliationList = () =>
  import("@/views/ReconciliationList/ReconciliationList.vue"); //特许店查询   
const direct_bill = () =>
  import("@/views/bill/direct_bill.vue"); //直营店查询    
const ChangePassword = () =>
  import("@/views/ChangePassword/ChangePassword.vue"); //订单打印
const franchise_sendbill = () =>
  import("@/views/bill/franchise_sendbill.vue"); //特许店杉德在线支付对账单查询
const franchise_voucherbill = () =>
  import("@/views/bill/franchise_voucherbill.vue"); //特许店线下支付对账单查询
const productdetail = () =>
  import("@/views/myProduct/ProductDetail.vue"); //产品详情
//const forgetpassword = () =>
//  import("@/views/login/forgetpassword.vue"); //忘记密码
const franchise_sendwithdrawalbill = () =>
  import("@/views/bill/franchise_sendwithdrawalbill.vue"); //杉德提现明细
const upload = () =>
  import("@/views/myProduct/upload.vue"); //上传图片
const uploadimg = () =>
  import("@/views/myProduct/uploadimg.vue"); //上传产品图片
//const orderlistnew = () =>
//  import("@/views/orderlist/orderlistnew.vue"); //订单列表-新
const hotellist = () =>
  import("@/views/hotel/hotellist.vue"); //酒店列表
const franchise_import = () =>
  import("@/views/importorder/franchise_import.vue"); //导入特许店订单
const importorderlist = () =>
  import("@/views/importorder/importorderlist.vue"); //已导入订单列表
const importorderdetail = () =>
  import("@/views/importorder/importorderdetail.vue"); //已导入订单详情，明细
const importorderinfo = () =>
  import("@/views/importorder/importorderinfo.vue"); //订单导入详情
const lease_import = () =>
  import("@/views/importorder/lease_import.vue"); //租赁订单导入
const project_import = () =>
  import("@/views/importorder/project_import.vue"); //工程订单导入
const evaluate = () =>
  import("@/views/honor/evaluate.vue"); //订单评价
const SKUevaluate = () =>
  import("@/views/honor/SKUevaluate.vue"); //产品评价
const SystemNoticeList = () =>
  import("@/views/systemNotice/SystemNoticeList.vue"); //系统公告
const shopcenter = () =>
  import("@/views/shop/shopcenter.vue"); //店铺管理
const prodlist = () =>
  import("@/views/prod/prod.vue"); //商品管理
const allprodlist = () =>
  import("@/views/prod/allprod.vue"); //全部商品
const preorderlist = () =>
  import("@/views/prod/preorder.vue"); //预订单金额导入
const editdetail = () =>
  import("@/views/prod/editdetail.vue"); //商品维护
const todolist = () =>
  import("@/views/home/todolist.vue"); //待办列表
const myorder = () =>
  import("@/views/orderlist/myorder.vue"); //我的订单（订单列表重新优化）
const order_notice = () =>
  import("@/views/article/order_notice.vue"); //订单管理须知
const product_notice = () =>
  import("@/views/article/product_notice.vue"); //商品管理须知
const shop_notice = () =>
  import("@/views/article/shop_notice.vue"); //店铺管理须知
const ReceiveObjectionList = () =>
  import("@/views/orderReceive/ReceiveObjectionList.vue"); //收货异议列表
//const UnConfirmPO = () =>
//  import("@/views/orderReceive/UnConfirmPO.vue"); //历史未完成订单状态确认页面
const supplierpaylist = () =>
  import("@/views/supplierpay/paylist.vue"); //供应商待付款列表
const supplierpaydetail = () =>
  import("@/views/supplierpay/paydetail.vue"); //供应商付款详情
const supplierinvoicelist = () =>
  import("@/views/supplierpay/invoicelist.vue"); //供应商发票列表
const rebatedetail = () =>
  import("@/views/rebate/rebatedetail.vue"); //返利账单列表
const rebatelist = () =>
  import("@/views/rebate/rebatelist.vue"); //返利账单详情
const spellOrderList = () =>
  import("@/views/spellOrder/spellOrderList.vue"); //拼团订单列表
const spellorderdetail = () =>
  import("@/views/spellOrder/spellorderdetail.vue"); //拼团订单详情
const spellprinting = () =>
  import("@/views/spellOrder/spellprinting.vue"); //拼团订单打印
const directOrderList = () =>
  import("@/views/orderList/directOrderList.vue"); //直营订单列表
const franchiseOrderList = () =>
  import("@/views/orderList/franchiseOrderList.vue"); //特许订单列表
const materialOrderList = () =>
  import("@/views/orderList/materialOrderList.vue"); //原材料订单列表
const orderDetail2 = () =>
  import("@/views/orderDetail/OrderDetail2.vue"); //订单详情-新
const help = () =>
  import("@/views/help/help.vue"); //帮助页
const orderreport = () =>
  import("@/views/query/orderreport.vue"); //订单报表查询
const hotelDesignDrawing = () =>
  import("@/views/query/HotelDesignDrawing.vue"); //酒店平面设计图查询
const logisticsaftersales = () =>
  import("@/views/prod/logisticsaftersales.vue"); //物流和售后信息维护
const electronicInvoice = () =>
  import("@/views/importorder/electronicInvoice.vue"); //批量导入电票
const licensedProducts = () =>
  import("@/views/franchiseOrder/licensedProducts.vue"); //特许产品加购
const shoppingCart = () =>
  import("@/views/franchiseOrder/shoppingCart.vue"); //购物车
const supplierSubmitList = () =>
  import("@/views/franchiseOrder/supplierSubmitList.vue"); //提交列表
const supplierKpiReward = () =>
  import("@/views/shop/supplierKpiReward.vue"); //扣分明细
const SupplierSurvey = () =>
  import("@/views/supplierSurvey/SupplierSurvey.vue"); //供应商平台调查问卷
const NonStandardReport = () =>
  import("@/views/nonStandard/NonStandardReport.vue"); //非标报备
const ManagementRegulation = () =>
  import("@/views/managementRegulation/ManagementRegulation.vue"); //管理条例
Vue.use(Router)





export default new Router({
  mode: "history",
  routes: [{
    path: '*',
    redirect: '/Home',
  },
  {
    path: '/Home',
    name: '/Home',
    component: Home,
    meta: {
      title: "首页",
      keep: false,
    }
  },

  {
    path: '/orderDetail',
    name: '/OrderDetail',
    component: OrderDetail,
    meta: {
      title: "订单详情",
      keep: false
    }

  },
  {
    path: '/ChangePassword',
    name: '/OrderChangePasswordDetail',
    component: ChangePassword,
    meta: {
      title: "修改密码",
      keep: false
    }

  },
  {
    path: '/ReconciliationList',
    name: '/ReconciliationList',
    component: ReconciliationList,
    meta: {
      title: "特许店对账查询",
      keep: false
    }

  },
  {
    path: '/direct_bill',
    name: '/direct_bill',
    component: direct_bill,
    meta: {
      title: "直营店对账查询",
      keep: false
    }
  },
  {
    path: '/reimBurse',
    name: '/ReimBurse',
    component: ReimBurse,
    meta: {
      title: "退货/退款",
      keep: false
    }

  },
  {
    path: '/myLogistics',
    name: '/MyLogistics',
    component: MyLogistics,
    meta: {
      title: "我的物流",
      keep: false
    }
  }, {
    path: '/myReport',
    name: '/MyReport',
    component: MyReport,
    meta: {
      title: "我的质检报告",
      keep: false
    }
  },
  {
    path: '/nonStandardReport',
    name: '/nonStandardReport',
    component: NonStandardReport,
    meta: {
      title: "非标报备",
      keep: false
    }
  },
  {
    path: '/franchise_settlementbill',
    name: '/franchise_settlementbill',
    component: franchise_settlementbill,
    meta: {
      title: "结算清单查询",
      keep: false
    }
  },
  {
    path: '/settlementDetailed',
    name: '/SettlementDetailed',
    component: SettlementDetailed,
    meta: {
      title: "查看明细",
      keep: false
    }
  },
  {
    path: '/invoiceEntry',
    name: '/InvoiceEntry',
    component: InvoiceEntry,
    meta: {
      title: "模拟发票",
      keep: false
    }
  },
  {
    path: '/newInvoiceEntry',
    name: '/NewInvoiceEntry',
    component: NewInvoiceEntry,
    meta: {
      title: "订单录入发票",
      keep: false,
      encryptedParams: ["ordersubno"]
    }
  },
  {
    path: '/settlementSheet',
    name: '/SettlementSheet',
    component: SettlementSheet,
    meta: {
      title: "结算单",
      keep: false
    }
  },
  { // 发票
    path: '/invoice',
    name: '/Invoice',
    component: Invoice,
    meta: {
      title: "发票",
      keep: false
    }
  },
  { // 酒店分配
    path: '/allot',
    name: '/Allot',
    component: Allot,
    meta: {
      title: "酒店分配",
      keep: false
    }

  },
  { // 荣誉
    path: '/honor',
    name: '/Honor',
    component: Honor,
    meta: {
      title: "我的信誉",
      keep: false
    }

  },
  {
    path: '/systemNotice',
    name: '/SystemNotice',
    component: SystemNotice,
    meta: {
      title: "系统公告",
      keep: false
    }
  },
  //{
  //  path: '/myProduct',
  //  name: '/MyProduct',
  //  component: MyProduct,
  //  meta: {
  //    title: "我的产品",
  //    keep: false
  //  }
  //},
  {
    path: '/Login',
    name: '/Login',
    component: Login,
    meta: {
      title: "登录",
      keep: false
    }
  },
  {
    path: '/auth/callback',
    name: '/AuthCallback',
    component: AuthCallback,
    meta: {
      title: "如家统一身份认证",
      keep: false
    }
  },
  {
    path: '/Err',
    name: '/Err',
    component: Err,
    meta: {
      title: "",
      keep: false
    }
  },
  {
    path: '/ChooHotel',
    name: '/ChooHotel',
    component: ChooHotel,
    meta: {
      title: "选择酒店",
      keep: false
    }
  },
  {
    path: '/advancepayment',
    name: '/advancepayment',
    component: advancePayment,
    meta: {
      title: "提前付款申请",
      keep: false
    }
  },
  {
    path: '/OrderPrintingDetails',
    name: '/OrderPrintingDetails',
    component: OrderPrintingDetails,
    meta: {
      title: "订单打印",
      keep: false,
      encryptedParams: ["ordersubno"]
    }
  },
  {
    path: '/franchise_sendbill',
    name: '/franchise_sendbill',
    component: franchise_sendbill,
    meta: {
      title: "特许店线上支付对账查询",
      keep: false
    }

  }
    ,
  {
    path: '/franchise_voucherbill',
    name: '/franchise_voucherbill',
    component: franchise_voucherbill,
    meta: {
      title: "特许店线下支付对账单查询",
      keep: false
    }

  },
  {
    path: '/productdetail',
    name: '/productdetail',
    component: productdetail,
    meta: {
      title: "产品详情",
      keep: false
    }

  },
  //{
  //  path: '/forgetpassword',
  //  name: '/forgetpassword',
  //  component: forgetpassword,
  //  meta: {
  //    title: "忘记密码",
  //    keep: false
  //  }

  //},
  {
    path: '/franchise_sendwithdrawalbill',
    name: '/franchise_sendwithdrawalbill',
    component: franchise_sendwithdrawalbill,
    meta: {
      title: "提现查询",
      keep: false
    }

  },
  {
    path: '/upload',
    name: '/upload',
    component: upload,
    meta: {
      title: "上传图片",
      keep: false
    }

  },
  {
    path: '/uploadimg',
    name: '/uploadimg',
    component: uploadimg,
    meta: {
      title: "上传产品图片",
      keep: false
    }

  },
  //{
  //  path: '/orderlistnew',
  //  name: '/orderlistnew',
  //  component: orderlistnew,
  //  meta: {
  //    title: "订单列表-新",
  //    keep: false
  //  }
  //},
  {
    path: '/hotellist',
    name: '/hotellist',
    component: hotellist,
    meta: {
      title: "酒店查询",
      keep: false
    }
  },
  {
    path: '/franchise_import',
    name: '/franchise_import',
    component: franchise_import,
    meta: {
      title: "特许订单导入",
      keep: false
    }
  },
  {
    path: '/importorderlist',
    name: '/importorderlist',
    component: importorderlist,
    meta: {
      title: "已导入特许订单",
      keep: false
    }
  }
    ,
  {
    path: '/importorderdetail',
    name: '/importorderdetail',
    component: importorderdetail,
    meta: {
      title: "订单导入详情",
      keep: false
    }
  },
  {
    path: '/importorderinfo',
    name: '/importorderinfo',
    component: importorderinfo,
    meta: {
      title: "订单导入详情",
      keep: false
    }
  }
    ,
  {
    path: '/lease_import',
    name: '/lease_import',
    component: lease_import,
    meta: {
      title: "租赁订单导入",
      keep: false
    }
  }
    ,
  {
    path: '/project_import',
    name: '/project_import',
    component: project_import,
    meta: {
      title: "工程订单导入",
      keep: false
    }
  },
  {
    path: '/evaluate',
    name: '/evaluate',
    component: evaluate,
    meta: {
      title: "订单评价",
      keep: false
    }
  },
  {
    path: '/SKUevaluate',
    name: '/SKUevaluate',
    component: SKUevaluate,
    meta: {
      title: "产品评价",
      keep: false
    }
  },
  {
    path: '/SystemNoticeList',
    name: '/SystemNoticeList',
    component: SystemNoticeList,
    meta: {
      title: "系统公告",
      keep: false
    }
  }
    ,
  {
    path: '/shopcenter',
    name: '/shopcenter',
    component: shopcenter,
    meta: {
      title: "店铺管理",
      keep: false
    }
  },
  {
    path: '/prodlist',
    name: '/prodlist',
    component: prodlist,
    meta: {
      title: "商品管理",
      keep: false
    }
  },
  {
    path: '/allprodlist',
    name: '/allprodlist',
    component: allprodlist,
    meta: {
      title: "产品目录",
      keep: false
    }
  },
  {
    path: '/preorderlist',
    name: '/preorderlist',
    component: preorderlist,
    meta: {
      title: "特许店工程预订单导入",
      keep: false
    }
  },
  {
    path: '/editdetail',
    name: '/editdetail',
    component: editdetail,
    meta: {
      title: "商品维护",
      keep: false
    }
  },
  {
    path: '/todolist',
    name: '/todolist',
    component: todolist,
    meta: {
      title: "全部待办",
      keep: false
    }
  },
  {
    path: '/myorder',
    name: '/myorder',
    component: myorder,
    meta: {
      title: "我的订单",
      keep: false
    }
  },
  {
    path: '/article_order',
    name: '/article_order',
    component: order_notice,
    meta: {
      title: "订单管理须知",
      keep: false
    }
  },
  {
    path: '/article_product',
    name: '/article_product',
    component: product_notice,
    meta: {
      title: "商品管理须知",
      keep: false
    }
  },
  {
    path: '/article_shop',
    name: '/article_shop',
    component: shop_notice,
    meta: {
      title: "店铺管理须知",
      keep: false
    }
  },
  {
    path: '/ReceiveObjectionList',
    name: '/ReceiveObjectionList',
    component: ReceiveObjectionList,
    meta: {
      title: "收货异议列表",
      keep: false
    }
  },
  //{
  //  path: '/UnConfirmPO',
  //  name: '/UnConfirmPO',
  //  component: UnConfirmPO,
  //  meta: {
  //    title: "历史未完成订单状态确认页面",
  //    keep: false
  //  }
  //},
  {
    path: '/supplierpaylist',
    name: '/supplierpaylist',
    component: supplierpaylist,
    meta: {
      title: "付款管理-付款列表",
      keep: false
    }
  },
  {
    path: '/supplierpaydetail',
    name: '/supplierpaydetail',
    component: supplierpaydetail,
    meta: {
      title: "付款管理-付款详情",
      keep: false,
      encryptedParams: ["preNo"]
    }
  },
  {
    path: '/supplierinvoicelist',
    name: '/supplierinvoicelist',
    component: supplierinvoicelist,
    meta: {
      title: "付款管理-发票列表",
      keep: false
    }
  },
  {
    path: '/rebatelist',
    name: '/rebatelist',
    component: rebatelist,
    meta: {
      title: "渠道使用服务费管理-渠道使用服务费账单列表",
      keep: false
    }
  },
  {
    path: '/rebatedetail',
    name: '/rebatedetail',
    component: rebatedetail,
    meta: {
      title: "渠道使用服务费管理-渠道使用服务费账单详情",
      keep: false,
      encryptedParams: ["rbno"]
    }
  },
  {
    path: '/spellOrderList',
    name: '/spellOrderList',
    component: spellOrderList,
    meta: {
      title: "拼团订单列表",
      keep: false
    }
  },
  {
    path: '/spellorderdetail',
    name: '/spellorderdetail',
    component: spellorderdetail,
    meta: {
      title: "拼团订单详情",
      keep: false
    }
  },
  {
    path: '/spellprinting',
    name: '/spellprinting',
    component: spellprinting,
    meta: {
      title: "拼团订单打印",
      keep: false
    }
  },
  {
    path: '/directOrderList',
    name: '/directOrderList',
    component: directOrderList,
    meta: {
      title: "直营订单",
      keep: false
    }
  },
  {
    path: '/franchiseOrderList',
    name: '/franchiseOrderList',
    component: franchiseOrderList,
    meta: {
      title: "特许订单",
      keep: false
    }
  },
  {
    path: '/materialOrderList',
    name: '/materialOrderList',
    component: materialOrderList,
    meta: {
      title: "原材料订单",
      keep: false
    }
  },
  {
    path: '/orderDetail2',
    name: '/orderDetail2',
    component: orderDetail2,
    meta: {
      title: "订单详情",
      keep: false,
      encryptedParams: ["id"]
    }
  },
  {
    path: '/help',
    name: '/help',
    component: help,
    meta: {
      title: "帮助中心",
      keep: false
    }
  },
  {
    path: '/orderreport',
    name: '/orderreport',
    component: orderreport,
    meta: {
      title: "订单报表查询",
      keep: false
    }
  },
  {
    path: '/hotelDesignDrawing',
    name: '/hotelDesignDrawing',
    component: hotelDesignDrawing,
    meta: {
      title: "酒店平面设计图查询",
      keep: false
    }
  },
  {
    path: '/logisticsaftersales',
    name: '/logisticsaftersales',
    component: logisticsaftersales,
    meta: {
      title: "物流和售后信息维护",
      keep: false
    }
  },
  {
    path: '/electronicInvoice',
    name: '/electronicInvoice',
    component: electronicInvoice,
    meta: {
      title: "批量导入电票",
      keep: false
    }
  },
  {
    path: '/licensedProducts',
    name: '/licensedProducts',
    component: licensedProducts,
    meta: {
      title: "特许产品加购",
      keep: false
    }
  },
  {
    path: '/shoppingCart',
    name: '/shoppingCart',
    component: shoppingCart,
    meta: {
      title: "购物车",
      keep: false
    }
  },
  {
    path: '/supplierSubmitList',
    name: '/supplierSubmitList',
    component: supplierSubmitList,
    meta: {
      title: "提交列表",
      keep: false
    }
  },
  {
    path: '/supplierKpiReward',
    name: '/supplierKpiReward',
    component: supplierKpiReward,
    meta: {
      title: "扣分明细",
      keep: false
    }
  },
  {
    path: '/supplierSurvey',
    name: '/supplierSurvey',
    component: SupplierSurvey,
    meta: {
      title: "供应商平台调查问卷",
      keep: false
    }
  },
  {
    path: '/managementRegulation',
    name: '/managementRegulation',
    component: ManagementRegulation,
    meta: {
      title: "管理条例",
      keep: false
    }
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }

    }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js